export default [
    {
      path: '/admin/agency/pickup-requests',
      name: 'pickup-request',
      meta: { requiresAuth: true },
      component: () => import('@/pages/agency/pickup-request/index.vue')
    }
  ]
